import { MgPrescription } from '@montugroup/icons';
import CalendarToday from '@mui/icons-material/CalendarToday';
import ContactSupportOutlined from '@mui/icons-material/ContactSupportOutlined';
import ContentPaste from '@mui/icons-material/ContentPaste';
import Home from '@mui/icons-material/Home';
import Person from '@mui/icons-material/Person';
import Receipt from '@mui/icons-material/Receipt';
import type { SvgIcon } from '@mui/material';

import {
  CONSULTATIONS_ROUTE,
  FAQ_ROUTE,
  HOME_ROUTE,
  MEDICINE_INFORMATION_ROUTE,
  PATIENT_ORDERS_ROUTE,
  PRESCRIPTIONS_ROUTE,
  PROFILE_DETAILS_ROUTE,
} from '@/routes/route-paths';

export const APP_BAR_HEIGHT = '77px';
export interface INavMenu {
  id: number;
  name: string;
  link: string;
  icon: typeof SvgIcon;
}

export const alternaleafAppBarConfig: INavMenu[] = [
  {
    id: 1,
    name: 'Home',
    link: HOME_ROUTE,
    icon: Home,
  },
  {
    id: 2,
    name: 'Consultations',
    link: CONSULTATIONS_ROUTE,
    icon: CalendarToday,
  },
  {
    id: 3,
    name: 'Prescriptions',
    link: PRESCRIPTIONS_ROUTE,
    icon: ContentPaste,
  },
  {
    id: 4,
    name: 'View orders',
    link: PATIENT_ORDERS_ROUTE,
    icon: Receipt,
  },
  {
    id: 5,
    name: 'Medicine information',
    link: MEDICINE_INFORMATION_ROUTE,
    icon: MgPrescription,
  },
  {
    id: 6,
    name: 'Profile',
    link: PROFILE_DETAILS_ROUTE,
    icon: Person,
  },
  {
    id: 7,
    name: 'Help',
    link: FAQ_ROUTE,
    icon: ContactSupportOutlined,
  },
];
